import React from 'react'

export const Content = () => {
  return (
    <h2 className='font-bold text-2xl'>Content</h2>
  )
}
